import AppointmentDialog from "./AppointmentDialog";

export default AppointmentDialog;